import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
// Map the canonical Customer tier strings (and the legacy A/B/C variants
// kept for backward compat with admin fixtures) to their display labels.
// P09-T20: switched from one-letter abbreviations ("S"/"B"/"G") to the full
// tier name so the storefront badge reads "SILVER -5%" / "GOLD -7.5%".
const LABEL = {
    A: "TIER A",
    B: "TIER B",
    C: "TIER C",
    standard: "STANDARD",
    bronze: "BRONZE",
    silver: "SILVER",
    gold: "GOLD",
};
// Tier-themed Tailwind classes resolving to the colour tokens added in
// packages/design-tokens/src/tokens.css. Legacy A/B/C reuse the standard
// (olive) palette since they're admin-fixture-only and never reach the
// storefront. Ivory background stays consistent across tiers for a
// uniform editorial feel; the metallic identity comes from the border +
// text colour.
const TIER_CLASSES = {
    A: "border-tier-standard text-tier-standard",
    B: "border-tier-standard text-tier-standard",
    C: "border-tier-standard text-tier-standard",
    standard: "border-tier-standard text-tier-standard",
    bronze: "border-tier-bronze text-tier-bronze",
    silver: "border-tier-silver text-tier-silver",
    gold: "border-tier-gold text-tier-gold",
};
function formatPct(pct) {
    return Number.isInteger(pct) ? pct.toString() : pct.toFixed(1);
}
export function TierBadge({ tier, percentage, className }) {
    const label = percentage !== undefined && percentage > 0
        ? `${LABEL[tier]} -${formatPct(percentage)}%`
        : LABEL[tier];
    return (_jsx("span", { "data-slot": "tier-badge", "data-tier": tier, title: `Tier ${tier}`, className: cn("inline-flex items-center rounded-xs border bg-ivory px-2 py-0.5 text-overline font-semibold uppercase tracking-[0.04em]", TIER_CLASSES[tier], className), children: label }));
}
